import request from '@/utils/request';
import { tansParams } from '@/utils/ruoyi';

export function getMovieListService(data) {
  return request({
    url: "/dp/movieList",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getScheduleCountService(data) {
  return request({
    url: "/dp/scheduleCount",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getCompanyNameService(data) {
  return request({
    url: "/dp/companyName",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getAreaListService(data) {
  return request({
    url: "/dp/areaList",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getPrefectureListService(data) {
  return request({
    url: "/dp/prefectureList",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getAreaChartService(data) {
  return request({
    url: "/dp/areaScheduleCount",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getPrefectureCountService(data) {
  return request({
    url: "/dp/prefectureScheduleCount",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getSeasonsService() {
  return request({
    url: "/dp/seasons",
    method: "get",
    params: {},
  });
}

export function getAllMovieOpenListService(data) {
  return request({
    url: "/dp/allMovieOpenList",
    method: "post",
    data: {
      ...data,
    },
  });
}

export function getMovieReviewService(data) {
  return request({
    url: "/dp/movieReview",
    method: "post",
    params: {
      ...data,
    },
  });
}

export function getHotwordService(data) {
  return request({
    url: "/dp/hotWord",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getHotwordCloudService(data) {
  return request({
    url: "/hotword/wordCloud",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getHotwordDemoGraphicService(data) {
  return request({
    url: "/hotword/demographic",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getHotwordBaseAnalysisService(data) {
  return request({
    url: "/hotword/basicAnalysis",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getMovieReviewDailyService(data) {
  return request({
    url: "/movieReview/daily",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getDailyBoxOfficeService(data) {
  return request({
    url: "/dp/dailyBoxOffice",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getSocialStatsService(data) {
  return request({
    url: "/socialStats/summary",
    method: "get",
    params: {
      ...data,
    },
  });
}

// Google トレンド 検索インタレスト：作品の最新スナップショット（期間パラメータ不要、DEV-14892）
// status: ok / no_data / failed / not_covered、points[].value は 0〜100 の相対値（null=データなし）
export function getTrendsService(data) {
  return request({
    url: "/socialStats/trends",
    method: "get",
    params: {
      ...data,
    },
  });
}

/** 最終興行収入予測（DEV-14891）：dp_bof_prediction の最新結果。予測なしの場合も stage=none + reason を返す */
export function getBoxOfficePredictionService(data) {
  return request({
    url: "/dp/boxOfficePrediction/latest",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getWeekDigestAIService(data) {
  return request({
    url: "/dp/weeklyDigest/ai",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getWeekDigestAIServiceV2(data) {
  return request({
    url: "/dp/weeklyDigest/ai/v2",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getHordwordSourceAnalysisService(data) {
  return request({
    url: "/hotword/sourceAnalysis",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getHotwordAudienceProfileService(data) {
  return request({
    url: "/hotword/audienceProfile",
    method: "get",
    params: {
      ...data,
    },
  });
}

/** 作品ランキング・近日票房趋势の配列パラメータ（地域2種。劇場ランキング専用のバージョン系は含まない） */
const MOVIE_MARKET_ARRAY_KEYS = ["areaIds", "prefectureIds"];

export function getMovieMarketRankService(data, config = {}) {
  return request({
    url: "/dp/movieMarketRank",
    method: "get",
    params: foldArrayParams(data, MOVIE_MARKET_ARRAY_KEYS),
    ...config,
  });
}

export function getMovieDailyTrendService(data, config = {}) {
  return request({
    url: "/dp/movieDailyTrend",
    method: "get",
    params: foldArrayParams(data, MOVIE_MARKET_ARRAY_KEYS),
    ...config,
  });
}

// 作品詳細「直近興行トレンド」の公開週切り替え（DEV-14945）：公開週（金曜〜木曜）7日分の日別興行収入
// weekNo 未指定ならサーバー側が「今日（JST）の属する週」を返す。0 以下は公開前の週。無料版では使わない
export function getMovieWeeklyTrendService(data, config = {}) {
  return request({
    url: "/dp/movieWeeklyTrend",
    method: "get",
    params: foldArrayParams(data, MOVIE_MARKET_ARRAY_KEYS),
    ...config,
  });
}

// 公开免费版 Dashboard 专用：免登录接口，服务端已固定为「当天+全国」，不接受 date/areaId 等参数
export function getPublicMovieMarketRankService(data, config = {}) {
  return request({
    url: "/open/movieMarketRank",
    method: "get",
    headers: { isToken: false },
    params: {
      ...data,
    },
    ...config,
  });
}

export function getPublicMovieDailyTrendService(data, config = {}) {
  return request({
    url: "/open/movieDailyTrend",
    method: "get",
    headers: { isToken: false },
    params: {
      ...data,
    },
    ...config,
  });
}

// 获取ベンチマーク比较作品：根据电影ID返回总合类似度>=65%的候选电影(最多3部)
export function getBenchmarkMoviesService(data, config = {}) {
  return request({
    url: "/comparableMovie/benchmark",
    method: "get",
    params: {
      ...data,
    },
    ...config,
  });
}


// ==================== ダッシュボード劇場ランキング ====================

/**
 * 配列パラメータをカンマ区切り文字列に畳む。
 *
 * request.js の tansParams は配列を `areaIds[0]=1&areaIds[1]=3` の形に展開するが、
 * この形式は Spring MVC の `Long[]` / `String[]` にはバインドされない。
 * カンマ区切り（areaIds=1,3）なら Spring 標準のコンバータがそのまま配列へ変換する。
 * 空配列は undefined に落として「未指定＝全て」を表す（tansParams は undefined を捨てる）。
 */
function foldArrayParams(data, keys) {
  const params = { ...data };
  keys.forEach((key) => {
    const value = params[key];
    if (Array.isArray(value)) {
      params[key] = value.length ? value.join(",") : undefined;
    }
  });
  return params;
}

/** 劇場ランキングの配列パラメータ（地域2種 + 上映バージョン4種） */
const CINEMA_RANK_ARRAY_KEYS = [
  "areaIds",
  "prefectureIds",
  "versionIds",
  "version1Ids",
  "version2Ids",
  "version3Ids",
];

// 劇場ランキング：作品を選んだ後、単一営業日 × 地域 × 上映バージョンで各劇場の実績を取得
// keyset（カーソル）ページング：前回レスポンスの nextCursor をそのまま cursor に渡すと次ページ
export function getCinemaRankService(data, config = {}) {
  return request({
    url: "/dp/cinemaRank",
    method: "get",
    params: foldArrayParams(data, CINEMA_RANK_ARRAY_KEYS),
    ...config,
  });
}

// 劇場ランキング：4種類の上映バージョン値の全量（available で上映の有無を判別）
export function getCinemaRankFilterOptionsService(data, config = {}) {
  return request({
    url: "/dp/cinemaRankFilterOptions",
    method: "get",
    params: foldArrayParams(data, CINEMA_RANK_ARRAY_KEYS),
    ...config,
  });
}

// 劇場週次詳細：公開週（金曜〜木曜）の日別興行収入・入場者数
// 上映バージョン条件はランキングと必ず揃えること（揃えないと数字が一致しない）
export function getCinemaWeeklyDetailService(data, config = {}) {
  return request({
    url: "/dp/cinemaWeeklyDetail",
    method: "get",
    params: foldArrayParams(data, CINEMA_RANK_ARRAY_KEYS),
    ...config,
  });
}

// ==================== 上映スケジュールAI：劇場/スクリーン設定（DEV-14981） ====================
// 対象劇場はログインアカウントに紐づく劇場（sys_user.cinema_id）をバックエンドが自動で決めるため cinemaId は渡さない

// 劇場特性・スクリーン設定を取得（未保存時は saved=false でマスタから影厅名・座席数を初期値として返す）
export function getScheduleAiSettingService() {
  return request({
    url: "/dp/scheduleAi/setting",
    method: "get",
  });
}

// 劇場特性・スクリーン設定を一括保存（strategy + screens 全量。削除した影厅は配列から外すだけ）
export function saveScheduleAiSettingService(data) {
  return request({
    url: "/dp/scheduleAi/setting",
    method: "put",
    data,
  });
}

// 経営戦略だけを保存（strengthText・audienceText・peakTimeText・strategyText。空欄は null）
export function saveScheduleAiSettingStrategyService(data) {
  return request({
    url: "/dp/scheduleAi/setting/strategy",
    method: "put",
    data,
  });
}

// スクリーンだけを保存（配列は全量・表示順。配列にない既存スクリーンは削除、新規は screenId=null）
export function saveScheduleAiSettingScreensService(data) {
  return request({
    url: "/dp/scheduleAi/setting/screens",
    method: "put",
    data,
  });
}

// 上映可能バージョンのプルダウン選択肢（2D/3D・上映方式・特殊）。スクリーンは属性ごとに複数選択して保存する
export function getScheduleAiSettingOptionsService() {
  return request({
    url: "/dp/scheduleAi/setting/options",
    method: "get",
  });
}

// ==================== 上映スケジュールAI：本館上映作品・バージョン登録（DEV-14982） ====================
// 対象劇場はログインアカウントからバックエンドが決めるため cinemaId は渡さない

// バージョンのプルダウン選択肢（2D/3D・上映方式・言語・特殊。値はすべて名称文字列）
export function getScheduleAiMovieOptionsService() {
  return request({
    url: "/dp/scheduleAi/movie/options",
    method: "get",
  });
}

// 作品マスタをタイトルで検索（TableDataInfo。登録済みは registered=true）
export function searchScheduleAiMovieService(params) {
  return request({
    url: "/dp/scheduleAi/movie/search",
    method: "get",
    params,
  });
}

// 本館の登録作品一覧（versions 付き）
export function getScheduleAiMovieListService() {
  return request({
    url: "/dp/scheduleAi/movie/list",
    method: "get",
  });
}

// 本館上映作品として登録（data は登録された 1 件。versions は空）
export function addScheduleAiMovieService(movieId) {
  return request({
    url: "/dp/scheduleAi/movie",
    method: "post",
    data: { movieId },
  });
}

// 本館上映期間・上映時間・バージョンを保存（versions は保存後の全量。既存は versionId を必ず付ける）
export function updateScheduleAiMovieService(id, data) {
  return request({
    url: `/dp/scheduleAi/movie/${id}`,
    method: "put",
    data,
  });
}

// 本館の登録を解除（作品マスタは削除されない）
export function removeScheduleAiMovieService(id) {
  return request({
    url: `/dp/scheduleAi/movie/${id}`,
    method: "delete",
  });
}

// 全国のスケジュールに出現したバージョン組み合わせ（上映前は通常空）
export function getScheduleAiMovieVersionSuggestionsService(movieId) {
  return request({
    url: `/dp/scheduleAi/movie/${movieId}/versionSuggestions`,
    method: "get",
  });
}

// 作品の実績パネル（観客属性・地域充填率・本館実績）
export function getScheduleAiMovieInsightService(movieId) {
  return request({
    url: `/dp/scheduleAi/movie/${movieId}/insight`,
    method: "get",
  });
}

// ==================== 上映スケジュールAI：タイムチャート作成（DEV-14983） ====================
// 対象劇場はログインアカウントからバックエンドが決めるため cinemaId は渡さない。
// 対象期間は dateFrom〜dateTo（yyyy-MM-dd、両端を含む、1〜14 日、開始曜日は自由）。
// 保存済みの期間と重なる期間も条件設定は保存できる。重なる日の上映回は AI 生成・上映回保存時に overwriteOverlap=true で上書きする

// 対象期間の入力・ルール・上映回・チェック結果・AI 説明をまとめて取得（未保存で保存済み期間と重なる場合は overlaps が返る）
export function getScheduleAiPlanService({ dateFrom, dateTo }) {
  return request({
    url: "/dp/scheduleAi/plan",
    method: "get",
    params: { dateFrom, dateTo },
  });
}

// 保存済みの期間一覧（開始日の降順）。期間選択で既存の期間を開くために使う
export function getScheduleAiPlanPeriodsService() {
  return request({
    url: "/dp/scheduleAi/plan/periods",
    method: "get",
  });
}

// 期間を削除（条件設定・ルール・上映回をまとめて削除。version が違えば 409）
export function deleteScheduleAiPlanService({ dateFrom, dateTo, version }) {
  return request({
    url: "/dp/scheduleAi/plan",
    method: "delete",
    params: { dateFrom, dateTo, version },
  });
}

// 期間の設定（CM・予告分数、清掃間隔、作品ごとの優先度・目標回数・要望テキスト）を保存
export function saveScheduleAiPlanInputService(data) {
  return request({
    url: "/dp/scheduleAi/plan/input",
    method: "put",
    data,
  });
}

// 配給要望・劇場要望の自由記述を AI でルールに解析（下書きを返すだけで保存しない）
export function parseScheduleAiPlanRulesService({ dateFrom, dateTo }) {
  return request({
    url: "/dp/scheduleAi/plan/rules/parse",
    method: "post",
    data: { dateFrom, dateTo },
  });
}

// 確認済みのルール一覧を保存（全量）
export function saveScheduleAiPlanRulesService(data) {
  return request({
    url: "/dp/scheduleAi/plan/rules",
    method: "put",
    data,
  });
}

// AI タイムチャート生成を開始（非同期。jobId を返す）
// 保存済みの期間と重なる場合は overwriteOverlap=true が必要（生成成功時に重なる日の上映回を上書き。なければ 4604）
export function generateScheduleAiPlanService({ dateFrom, dateTo, overwriteOverlap = false }) {
  return request({
    url: "/dp/scheduleAi/plan/generate",
    method: "post",
    data: { dateFrom, dateTo, overwriteOverlap },
  });
}

// AI 生成ジョブの状態（RUNNING / SUCCESS / FAILED）
export function getScheduleAiPlanJobService(jobId) {
  return request({
    url: `/dp/scheduleAi/plan/generate/${jobId}`,
    method: "get",
  });
}

// 編集中の上映回をチェック（保存しない）。編集のたびに呼ぶため重複送信チェックは外す
export function validateScheduleAiPlanService(data) {
  return request({
    url: "/dp/scheduleAi/plan/validate",
    method: "post",
    data,
    headers: { repeatSubmit: false },
  });
}

// 上映回を保存（違反があり confirmNonCompliant=false のときは saved=false で違反一覧を返す）
// 保存済みの期間と重なる場合は overwriteOverlap=true が必要（重なる日の上映回を上書き。なければ 4604）
export function saveScheduleAiPlanShowsService(data) {
  return request({
    url: "/dp/scheduleAi/plan/shows",
    method: "put",
    data,
  });
}

// ==================== 上映スケジュールAI：タイムチャートの出力・共有（DEV-14984） ====================
// 対象劇場はログインアカウントからバックエンドが決めるため cinemaId は渡さない。対象期間は dateFrom〜dateTo（yyyy-MM-dd）

// 出力用プレビュー（表頭情報・準拠判定・未達の制約・スクリーン×日ごとの上映回）
export function getScheduleAiExportPreviewService({ dateFrom, dateTo }) {
  return request({
    url: "/dp/scheduleAi/export/preview",
    method: "get",
    params: { dateFrom, dateTo },
  });
}

// タイムチャートのファイル出力（dateFrom・dateTo・format：csv / xlsx / pdf・version はプレビューの値をそのまま送る）
// 失敗時は JSON（AjaxResult）が Blob で返るため、呼び出し側で type を見て判定する
export function downloadScheduleAiExportService(data) {
  return request({
    url: "/dp/scheduleAi/export/download",
    method: "post",
    data,
    transformRequest: [(params) => tansParams(params)],
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    responseType: "blob",
    // 生成に時間がかかる PDF も考慮してタイムアウトを延ばす
    timeout: 3 * 60 * 1000,
  });
}
